import angular from 'angular'
import './configurations.service'

angular
  .module('admin.configurations', ['admin.configurations.service'])
  .controller('ConfigurationsCtrl', ConfigurationsCtrl)

/** @ngInject */
function ConfigurationsCtrl($scope, ConfigurationsService, UploadService) {
  var vm = this
  vm.items = []

  vm.sortType = 'key'
  vm.sortReverse = true
  vm.search = null
  vm.allItems = []

  var oldSortType
  function load() {
    oldSortType = angular.copy(vm.sortType)
    ConfigurationsService.list().then(function(result) {
      vm.sortType = oldSortType
      vm.items = result.results
      vm.allItems = angular.copy(vm.items)
      if (vm.search) {
        vm.items = _.filter(vm.allItems, function(o) {
          return (
            o.key.toLowerCase().indexOf(vm.search.toLowerCase()) !== -1 ||
            o.val.toLowerCase().indexOf(vm.search.toLowerCase()) !== -1
          )
        })
      }
    })
  }

  load()

  vm.add = function() {
    vm.config = {
      id: 0,
      key: '',
      value: '',
    }
    $('#modalConfig').modal('show')
  }

  vm.edit = function(item) {
    vm.config = angular.copy(item)
    try {
      if (isNaN(Number(vm.config.val))) {
        vm.config.val = JSON.stringify(JSON.parse(vm.config.val), null, 2)
        vm.config.isJson = true
      } else {
        vm.config.isJson = false
      }
    } catch (e) {
      vm.config.isJson = false
    }

    if (vm.config.key === 'WEB_CONFIG_LOGO_NAVBAR') {
      vm.config.img = true
    } else {
      vm.config.img = false
    }

    $('#modalConfig').modal('show')
  }

  vm.save = function() {
    if (!vm.config.key) {
      swal('You need add a Key', '', 'warning')
      return
    }

    if (!vm.config.val) {
      swal('You need add a Value', '', 'warning')
      return
    }

    var existItem = _.filter(vm.allItems, function(o) {
      return o.key === vm.config.key && o.id !== 0
    })

    if (existItem.length === 0) {
      ConfigurationsService.set(vm.config.key, { value: vm.config.val }).then(function() {
        vm.sortType = oldSortType
        load()
        $('#modalConfig').modal('hide')
        vm.config = null
      })
    } else {
      swal(
        {
          title: 'Are you sure?',
          text: 'You will change the value of an existing record.',
          type: 'warning',
          showCancelButton: true,
          closeOnConfirm: true,
          closeOnCancel: true,
          animation: 'slide-from-top',
        },
        function(isConfirm) {
          if (isConfirm) {
            ConfigurationsService.set(vm.config.key, {
              value: vm.config.val,
            }).then(function() {
              vm.sortType = oldSortType
              load()
              $('#modalConfig').modal('hide')
              vm.config = null
            })
          }
        },
      )
    }
  }

  vm.cancel = function() {
    vm.config = null
    $('#modalConfig').modal('hide')
  }

  vm.sort = function(type) {
    vm.sortReverse = !vm.sortReverse
    if (vm.sortReverse) {
      vm.sortType = type + '-asc'
      vm.items = _.orderBy(vm.items, type, ['asc'])
    } else {
      vm.sortType = type + '-desc'
      vm.items = _.orderBy(vm.items, type, ['desc'])
    }
  }

  var watch = $scope.$watch('vm.search', function(newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null || newVal === '') {
      if (oldVal) {
        load()
      }
      return
    }

    if (newVal === false) {
      return
    }

    if (newVal.length < 2) {
      return
    }

    vm.items = _.filter(vm.allItems, function(o) {
      return (
        o.key.toLowerCase().indexOf(newVal.toLowerCase()) !== -1 ||
        o.val.toLowerCase().indexOf(newVal.toLowerCase()) !== -1
      )
    })
  })

  $scope.$on('$destroy', function() {
    watch()
  })

  vm.backLogo = function(item) {
    item.val = 'https://imager-prod.streetteam.dev/website/public/assets/icons/logo.svg'
  }

  vm.loadImg = false
  vm.pathImg = null
  vm.uploadImg = function(item) {
    vm.loadImg = true

    // if (vm.pathImg.type !== "image/svg+xml") {
    //   swal("Only supported svg images", "", "warning");
    //   vm.loadImg = false;
    //   return;
    // }

    // GET TYPE FILE
    var type = vm.pathImg.name.split('.')
    type = type[type.length - 1]

    UploadService.saveFixed(
      'website/public/assets/icons/logo',
      vm.pathImg,
      'logo_' + new Date().getTime() + '.' + type,
    ).then(function(fileName) {
      vm.loadImg = false
      if (
        window.location.href.indexOf('dev') !== -1 ||
        window.location.href.indexOf('localhost') !== -1
      ) {
        item.val = 'https://imager-dev.onquidd.com/website/public/assets/icons/logo/' + fileName
      } else {
        item.val = 'https://imager-prod.streetteam.dev/website/public/assets/icons/logo/' + fileName
      }
    })
  }
}
